import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import RoleManagement from "./pages/RoleManagement/RoleManagement";
import AddRoleManagement from "./pages/RoleManagement/AddRoleManagement/AddRoleManagement";
import { ToastContainer } from "react-toastify";
import RolePermissions from "./pages/RoleManagement/RolePermissions/RolePermissions";
import PageNotFound from "./errorBoundaries/PageNotFound/PageNotFound";
import Home from "./pages/Home/Home";
import DepotManagement from "./pages/DepotManagement/DepotManagement";
import AddUpdateDepotManagement from "./pages/DepotManagement/AddUpdateDepotManagement/AddUpdateDepotManagement";
import UnAthorize from "./errorBoundaries/UnAuthorize/UnAthorize";
import LotManagement from "./pages/LotManagement/LotManagement";
import AddUpdateLotManagement from "./pages/LotManagement/AddUpdateLotManagement/AddUpdateLotManagement";
import LabelGroupManagement from "./pages/LabelGroupManagement/LabelGroupManagement";
import AddUpdateLabelGroupManagement from "./pages/LabelGroupManagement/AddUpdateLabelGroupManagement/AddUpdateLabelGropuManagement";
import DrugTypeManagement from "./pages/DrugTypeManagement/DrugTypeManagement";
import AddUpdateDrugType from "./pages/DrugTypeManagement/AddUpdateDrugType/AddUpdateDrugType";
import DoseLevelManagement from "./pages/DoseLevelManagement/DoseLevelManagement";
import AddUpdateDoseLevel from "./pages/DoseLevelManagement/AddUpdateDoseLevel/AddUpdateDoseLevel";
import { createContext, useEffect, useState } from "react";
import ResupplySettings from "./pages/ResupplySettings/ResupplySettings";
import AddUpdateResupplySettings from "./pages/ResupplySettings/AddUpdateResupplySettings/AddUpdateResupplySettings";
import DrugAssignmentBatchRelease from "./pages/DrugAssignmentBatchRelease/DrugAssignmentBatchRelease";
import { NavigationGuardProvider } from "./context/NavigationGuardProvider ";
import RoleSubscriptions from "./pages/RoleManagement/RoleSubscriptions/RoleSubscriptions";
import RoleReports from "./pages/RoleManagement/RoleReports/RoleReports";
import IndividualBatchRelease from "./pages/DrugAssignmentBatchRelease/IndividualBatchRelease/IndividualBatchRelease";
import PageNotFoundWithoutNav from "./errorBoundaries/PageNotFound/PageNotFoundWithoutNav";
import CohortManagement from "./pages/CohortManagement/CohortManagement";
import AddUpdateCohortManagement from "./pages/CohortManagement/AddUpdateCohortManagement/AddUpdateCohortManagement";
import MaterialListApproval from "./pages/MaterialListApproval/MaterialListApproval";
import DispensationManagement from "./pages/DispensationManagement/DispensationManagement";
import AddUpdateDispensationManagement from "./pages/DispensationManagement/AddUpdateDispensation/AddUpdateDispensation";
import AddUpdateDispensationDetail from "./pages/DispensationManagement/AddUpdateDispensationDetail/AddUpdateDispensationDetail";
import BatchReleaseApproval from "./pages/BatchReleaseApproval/BatchReleaseApproval";
import BulkDrugKitStatus from "./pages/DrugKitStatus/BulkKitStatus/BulkDrugKitStatus";
import IndividualDrugKitStatus from "./pages/DrugKitStatus/IndividualKitStatus/IndividualKitStatus";
import Subject from "./pages/Subject/Subject";
import SiteManagement from "./pages/SiteManagement/SiteManagement";
import AddUpdateSiteManagement from "./pages/SiteManagement/AddUpdateSiteManagement/AddUpdateSiteManagement";
import IndividualKitStatus from "./pages/SiteManagement/AddUpdateSiteManagement/ManageSite/KitStatusSiteManagement/IndividualKitStatus";
import BulkKitStatus from "./pages/SiteManagement/AddUpdateSiteManagement/ManageSite/KitStatusSiteManagement/BulkKitStatus";
import DrugOrderManagement from "./pages/DrugOrderManagement/DrugOrderManagement";
import AddSubject from "./pages/Subject/AddUpdateSubject/AddSubject";
import UpdateSubject from "./pages/Subject/AddUpdateSubject/UpdateSubject";
import BulkEditSite from "./pages/SiteManagement/BulkEditSite/BulkEditSite";
import DataCorrection from "./pages/Subject/AddUpdateSubject/DataCorrection/DataCorrection";
import RandomizationTreatment from "./pages/Subject/AddUpdateSubject/RandomizationTreatment/RandomizationTreatment";
import SubjectTest from "./pages/Subject/AddUpdateSubject/SubjectTest/SubjectTest";
import AddUpdateDrugOrder from "./pages/DrugOrderManagement/AddUpdateDrugOrder/AddUpdateDrugOrder";
import AcknowledgeDrugOrder from "./pages/DrugOrderManagement/AddUpdateDrugOrder/AcknowledgeDrugOrder/AcknowledgeDrugOrder";
import CancelDrugOrder from "./pages/DrugOrderManagement/AddUpdateDrugOrder/CancelDrugOrder/CancelDrugOrder";
import ShipmentDrugOrder from "./pages/DrugOrderManagement/AddUpdateDrugOrder/ShipmentDrugOrder/ShipmentDrugOrder";
import QuarantineDrugOrder from "./pages/DrugOrderManagement/AddUpdateDrugOrder/QuarantineDrugOrder/QuarantineDrugOrder";
import PillCountManagement from "./pages/PillCountManagement/PillCountManagement";
import StudyCaps from "./pages/StudyCaps/StudyCaps";
import ReconcileDrugSite from "./pages/SiteManagement/AddUpdateSiteManagement/ManageSite/ReconcileDrugSite/ReconcileDrugSite";
import SiteReturnDepot from "./pages/SiteManagement/AddUpdateSiteManagement/ManageSite/SiteReturnDepot/SiteReturnDepot";
import SiteNotFound from "./errorBoundaries/SiteNotFound/SiteNotFound";
import SubjectVisit from "./pages/Subject/AddUpdateSubject/SubjectVisit/SubjectVisit";
import UnblindSubject from "./pages/Subject/AddUpdateSubject/UnblindSubject/UnblindSubject";
import SubjectVisitEntry from "./pages/Subject/AddUpdateSubject/SubjectVisitEntry/SubjectVisitEntry";
import OverrideRandomization from "./pages/Subject/AddUpdateSubject/OverrideRandomization/OverrideRandomization";
import DataCorrectionTwo from "./pages/Subject/AddUpdateSubject/DataCorrection/DataCorrectionTwo";
import DataCorrections from "./pages/DataCorrection/DataCorrections";
import AddDataCorrections from "./pages/DataCorrection/AddDataCorrections/AddDataCorrections";
import ApproveRejectDataCorrections from "./pages/DataCorrection/ApproveRejectDataCorrections/ApproveRejectDataCorrections";
import ReferenceMaterialManagement from "./pages/ReferenceMaterialManagement/ReferenceMaterialManagement";
import ReferenceMaterial from "./pages/ReferenceMaterial/ReferenceMaterial";
import Export from "./pages/Export/Export";

export const MenuContext = createContext([]);

function App() {
  const [systemActions, setSystemActions] = useState([]);
  const [permissions, setPermissions] = useState({
    viewDepotList: true,
    viewLotList: true,
    viewRoleList: true,
    viewDrugTypeList: true,
    viewLabelGroupList: true,
    viewResupplySettings: true,
    viewDoseLevelList: true,
    viewCohortList: true,
    viewDispensationList: true,
    viewSiteManagement: true,
    viewPatientList: true,
  });

  const {
    viewLotList,
    viewDepotList,
    viewRoleList,
    viewDrugTypeList,
    viewLabelGroupList,
    viewResupplySettings,
    viewDoseLevelList,
    viewCohortList,
    viewDispensationList,
    viewSiteManagement,
    viewPatientList,
  } = permissions;

  const role = localStorage.getItem("role");

  useEffect(() => {
    if (systemActions?.length > 0 && role !== "Admin") {
      const viewDepot = systemActions?.find(
        (item) => item?.name === "CanSeeDepotList",
      );
      const viewLot = systemActions?.find(
        (item) => item?.name === "CanSeeLotList",
      );
      const viewRole = systemActions?.find(
        (item) => item?.name == "CanViewRolesList",
      );

      const viewDrugType = systemActions?.find(
        (item) => item?.name == "CanSeeDrugTypeList",
      );

      const viewLabelGroup = systemActions?.find(
        (item) => item?.name == "CanSeeLabelGroupsList",
      );

      const viewResupplySettings = systemActions?.find(
        (item) => item?.name == "CanViewResupplySettings",
      );

      const viewDoseLevel = systemActions?.find(
        (item) => item?.name == "CanViewDosageLevel",
      );

      const viewCohortList = systemActions?.find(
        (item) => item?.name == "CanViewCohortManagement",
      );

      const viewDispensationList = systemActions?.find(
        (item) => item?.name == "CanViewDispensationList",
      );

      const viewSiteManagementPage = systemActions?.find(
        (item) => item?.name == "CanViewSiteManagement",
      );
      const viewPatientListPage = systemActions?.find(
        (item) => item?.name == "CanSeePatientList",
      );

      setPermissions((prev) => ({
        ...prev,
        viewLotList: viewLot ? true : false,
        viewDepotList: viewDepot ? true : false,
        viewRoleList: viewRole ? true : false,
        viewDrugTypeList: viewDrugType ? true : false,
        viewLabelGroupList: viewLabelGroup ? true : false,
        viewResupplySettings: viewResupplySettings ? true : false,
        viewDoseLevelList: viewDoseLevel ? true : false,
        viewCohortList: viewCohortList ? true : false,
        viewDispensationList: viewDispensationList ? true : false,
        viewSiteManagement: viewSiteManagementPage ? true : false,
        viewPatientList: viewPatientListPage ? true : false,
      }));
    }
  }, [systemActions]);

  return (
    <div className="App">
      <NavigationGuardProvider>
        <MenuContext.Provider value={{ systemActions, setSystemActions }}>
          <Router>
            <Routes>
              <Route path="/" element={<Home />}>
                <Route
                  path="/role-management"
                  element={
                    viewRoleList ? (
                      <RoleManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                ></Route>
                <Route
                  path="/add-role-management"
                  element={<AddRoleManagement />}
                ></Route>
                <Route
                  path="/role-permissions"
                  element={<RolePermissions />}
                ></Route>
                <Route
                  path="/role-subscriptions"
                  element={<RoleSubscriptions />}
                ></Route>
                <Route path="/role-reports" element={<RoleReports />}></Route>
                <Route
                  path="/depot-management"
                  element={
                    viewDepotList ? (
                      <DepotManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                ></Route>
                <Route
                  path="addUpdate-depot-management"
                  element={<AddUpdateDepotManagement />}
                />
                <Route
                  path="/lots-management"
                  element={
                    viewLotList ? <LotManagement /> : <PageNotFoundWithoutNav />
                  }
                />
                <Route
                  path="/addUpdate-lot-management"
                  element={<AddUpdateLotManagement />}
                />
                <Route
                  path="/label-group-management"
                  element={
                    viewLabelGroupList ? (
                      <LabelGroupManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-label-group-management"
                  element={<AddUpdateLabelGroupManagement />}
                />
                <Route
                  path="/drug-type-management"
                  element={
                    viewDrugTypeList ? (
                      <DrugTypeManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-drug-type"
                  element={<AddUpdateDrugType />}
                />
                <Route
                  path="/dose-level-management"
                  element={
                    viewDoseLevelList ? (
                      <DoseLevelManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-dose-level-management"
                  element={<AddUpdateDoseLevel />}
                />
                <Route
                  path="/resupply-settings"
                  element={
                    viewResupplySettings ? (
                      <ResupplySettings />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-resupply-settings"
                  element={<AddUpdateResupplySettings />}
                />
                <Route
                  path="/drug-assignment-batch-release"
                  element={<DrugAssignmentBatchRelease />}
                />
                <Route
                  path="/drug-assignment-individual-release"
                  element={<IndividualBatchRelease />}
                />
                <Route
                  path="/Cohort-management"
                  element={
                    viewCohortList ? (
                      <CohortManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-cohort-management"
                  element={<AddUpdateCohortManagement />}
                />
                <Route
                  path="/material-list-approval"
                  element={<MaterialListApproval />}
                />
                <Route
                  path="/dispensation-management"
                  element={
                    viewDispensationList ? (
                      <DispensationManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-dispensation-management"
                  element={<AddUpdateDispensationManagement />}
                />
                <Route
                  path="/add-dispensation-details"
                  element={<AddUpdateDispensationDetail />}
                />
                <Route
                  path="/batch-release-approval"
                  element={<BatchReleaseApproval />}
                />
                <Route
                  path="/bulk-drug-kit-status"
                  element={<BulkDrugKitStatus />}
                />
                <Route
                  path="/individual-drug-kit-status"
                  element={<IndividualDrugKitStatus />}
                />
                <Route path="/data-corrections" element={<DataCorrections />} />
                <Route
                  path="/approve-reject-data-corrections"
                  element={<ApproveRejectDataCorrections />}
                />
                <Route
                  path="/add-data-corrections"
                  element={<AddDataCorrections />}
                />
                <Route
                  path="/subject"
                  element={
                    viewPatientList ? <Subject /> : <PageNotFoundWithoutNav />
                  }
                ></Route>
                <Route path="/add-subject" element={<AddSubject />} />
                <Route path="/update-subject" element={<UpdateSubject />} />
                <Route path="/visit-subject" element={<SubjectVisit />} />
                <Route
                  path="/subject-visit-entry"
                  element={<SubjectVisitEntry />}
                />

                <Route
                  path="/subject-data-correction"
                  element={<DataCorrection />}
                />

                <Route
                  path="/subject-data-correction2"
                  element={<DataCorrectionTwo />}
                />
                <Route path="/unblind-subject" element={<UnblindSubject />} />
                <Route
                  path="/subject-randomization-treatment"
                  element={<RandomizationTreatment />}
                />
                <Route
                  path="/override-randomization-subject"
                  element={<OverrideRandomization />}
                />
                <Route path="/subject-test" element={<SubjectTest />} />
                <Route
                  path="/drug-shipment-management"
                  element={<DrugOrderManagement />}
                ></Route>
                <Route
                  path="/addUpdate-drug-order"
                  element={<AddUpdateDrugOrder />}
                ></Route>
                <Route
                  path="/cancel-drug-order"
                  element={<CancelDrugOrder />}
                ></Route>
                <Route
                  path="/acknowledge-drug-order"
                  element={<AcknowledgeDrugOrder />}
                ></Route>
                <Route
                  path="/acknowledge-detailed-drug-order"
                  element={<ShipmentDrugOrder />}
                ></Route>
                <Route
                  path="/quarantine-drug-order"
                  element={<QuarantineDrugOrder />}
                ></Route>
                <Route
                  path="/site-management"
                  element={
                    viewSiteManagement ? (
                      <SiteManagement />
                    ) : (
                      <PageNotFoundWithoutNav />
                    )
                  }
                />
                <Route
                  path="/addUpdate-site-management"
                  element={<AddUpdateSiteManagement />}
                ></Route>
                <Route
                  path="/site-management-reconcile-drug"
                  element={<ReconcileDrugSite />}
                ></Route>
                <Route
                  path="/site-management-site-return-depot"
                  element={<SiteReturnDepot />}
                ></Route>
                <Route
                  path="/individual-kit-status"
                  element={<IndividualKitStatus />}
                ></Route>
                <Route
                  path="/bulk-kit-status"
                  element={<BulkKitStatus />}
                ></Route>
                <Route
                  path="/bulk-edit-site"
                  element={<BulkEditSite />}
                ></Route>
                <Route
                  path="/pill-count-management"
                  element={<PillCountManagement />}
                ></Route>
                <Route path="/study-caps" element={<StudyCaps />}></Route>
                <Route
                  path="/upload-reference-materials"
                  element={<ReferenceMaterialManagement />}
                ></Route>
                <Route
                  path="/reference-materials"
                  element={<ReferenceMaterial />}
                ></Route>
                <Route
                  path="/Export"
                  element={<Export />}
                />
              </Route>
              {/* <Route path="*" element={<Navigate to="/pageNotFound" replace />} />
          <Route path="/pageNotFound" element={<PageNotFound />} /> */}
              <Route path="*" element={<PageNotFound />} />
              <Route path="/unauthorize" element={<UnAthorize />}></Route>
              <Route path="/siteNotFound" element={<SiteNotFound />}></Route>
            </Routes>
          </Router>
          <ToastContainer />
        </MenuContext.Provider>
      </NavigationGuardProvider>
    </div>
  );
}

export default App;
